module.exports = __webpack_public_path__ + "1deb7118d76fed12c159c60360b3c006.png";